export class Mobile {
  constructor({
    mobileID = 0,
    orderType = null,
    mobileNumber = null,
    ratePlanID = 0,
    simCardNo = null,
    state = null,
    currentCarrier = null,
    accountNo = null,
    addressID = 0,
    serviceLocationID = 0,
    dateOfBirth = null,
    contractLengthMonths = null,
    bundleId = 0,
  } = {}) {
    this.mobileID = mobileID;
    this.orderType = orderType;
    this.mobileNumber = mobileNumber;
    this.ratePlanID = ratePlanID;
    this.simCardNo = simCardNo;
    this.state = state;
    this.currentCarrier = currentCarrier;
    this.accountNo = accountNo;
    this.addressID = addressID;
    this.serviceLocationID = serviceLocationID;
    this.dateOfBirth = dateOfBirth;
    this.contractLengthMonths = contractLengthMonths;
    this.bundleId = bundleId;
  }
}

export function CreateNewMobile(data) {
  return Object.freeze(new Mobile(data));
}
